var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { appColors } from '../assets/appColors';
var parsePercentage = function (percentage) {
    var cleaned = percentage.replace(/[^0-9]/g, '');
    var value = parseInt(cleaned, 10);
    if (percentage.includes('<') && value < 5) {
        return 5;
    }
    return value;
};
export var Graph = function (_a) {
    var title = _a.title, percentage = _a.percentage, isFirstItem = _a.isFirstItem;
    if (!percentage) {
        return null;
    }
    var parsedPercentage = parsePercentage(percentage);
    return (_jsxs(Box, { sx: __assign(__assign({}, graphContainer), { mt: { xs: isFirstItem ? 1 : 2, md: 0 } }), children: [_jsx(Typography, { sx: titleStyle, children: title }), _jsx(Box, { sx: barBackgroundStyle, children: _jsx(Box, { sx: barLevelStyle(parsedPercentage), children: _jsxs(Typography, { fontWeight: 700, children: [parsedPercentage, "%"] }) }) })] }));
};
var graphContainer = {
    display: {
        xs: 'flex',
        md: 'grid',
    },
    flexDirection: 'column',
    gridTemplateColumns: '1fr 2fr',
    mt: { xs: 2, md: 0 },
};
var titleStyle = {
    fontSize: '16px',
    marginBottom: '8px',
    fontWeight: 500,
};
var barBackgroundStyle = {
    height: '24px',
    backgroundColor: appColors.color.taupe2,
    borderRadius: '5px',
    position: 'relative',
};
var barLevelStyle = function (percentage) {
    return ({
        height: '100%',
        width: "".concat(percentage, "%"),
        backgroundColor: appColors.neutral.lightGray,
        borderRadius: '2px',
        position: 'relative',
        fontWeight: 800,
        fontSize: '12px',
        color: appColors.neutral.black,
        paddingLeft: '10px',
    });
};
